import {
    CaseReducer,
    createAsyncThunk,
} from '@reduxjs/toolkit'
import {
    NinchatActionType,
    NinchatTransferAudienceAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
    NinchatClientPromiseValue,
} from '../NinchatClient'
import {NinchatEventType} from '../types/events'
import {NinchatEvents} from '../types'
import {channelParted} from '../event/channelParted'
import {channelUpdated} from '../event/channelUpdated'

const actionTypePrefix = 'NINCHAT/action'

type MetaReducerAsyncThunkConfig = {fulfilledMeta: {reducer: CaseReducer}}

export const transferAudience = createAsyncThunk<NinchatClientPromiseValue, NinchatActionParams<NinchatTransferAudienceAction>, MetaReducerAsyncThunkConfig>(
    `${actionTypePrefix}/${NinchatActionType.NinchatTransferAudienceAction}`,
    async (arg, thunkAPI) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatTransferAudienceAction

        try {
            const event = await ninchatClient.send(params) as NinchatEvents.NinchatEvent

            /* eslint-disable indent, multiline-ternary */
            const reducer =
                event.event === NinchatEventType.NinchatChannelPartedEvent ? channelParted.reducer :
                event.event === NinchatEventType.NinchatChannelUpdatedEvent ? channelUpdated.reducer :
                () => undefined
            /* eslint-enable */

            const meta = {reducer}

            return thunkAPI.fulfillWithValue(event, meta)
        } catch (err) {
            return thunkAPI.rejectWithValue(err)
        }
    },
)
